<app-loading *ngIf="isLoading"></app-loading>
<div class="main-container">
  <div class="title-container">
    <div class="row main-title pt-3">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 py-0">
        <label>{{ "claimOffice.label.fraudcaseOverview" | translate }}</label>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 text-right">
        <img
          src="{{
            this.RESOURCE_SERVER_URL +
              '/assets/images/process-claims/Claim-Review/Back.svg'
          }}"
          alt=""
        />
      </div>
    </div>
  </div>
  <ng-container >
  <div class="detail-container">
    <ng-container *ngIf="countdetails != undefined">
    <div fxLayout="row wrap" fxLayoutGap="16px grid">
      <div fxFlex="20%" fxFlex.xs="100%" fxFlex.sm="100%">
        <div class="card nothreat">
          <p>10 <img [src]="fraudIconDark" class="aiIcon"></p>
          <!-- <p>{{countdetails.noThreat==0?'10':countdetails.noThreat}}</p> -->
          <p class="">No Threat</p>
        </div>
      </div>
      <div fxFlex="20%" fxFlex.xs="100%" fxFlex.sm="100%">
        <div class="card probablyfraudclaims">
          <p>{{countdetails.probableFraudClaim}} <img [src]="fraudIconDark" class="aiIcon"></p>
          <p class="">Potential Fraud Claims</p>
        </div>
      </div>
      <div fxFlex="20%" fxFlex.xs="100%" fxFlex.sm="100%">
        <div class="card watchlist">
          <p>{{countdetails.watchList}}</p>
          <p class="">Watch List</p>
        </div>
      </div>
      <div fxFlex="20%" fxFlex.xs="100%" fxFlex.sm="100%">
        <div class="card identifiedFraud">
          <p>{{countdetails.identifiedFraud}}</p>
          <p class="">Identified Fraud</p>
        </div>
      </div>
      <div fxFlex="20%" fxFlex.xs="100%" fxFlex.sm="100%">
        <div class="card cleared">
          <p>{{countdetails.cleared}}</p>
          <p class="">Cleared</p>
        </div>
      </div>
    </div>
    <div fxLayout="row wrap" class="pt-3" fxLayoutGap="16px grid">
      <div fxFlex="50%" fxFlex.xs="100%" fxFlex.sm="100%">
        <div class="graph">
          <h6 class="pl-4 pb-5">Claims Count Total</h6>
          <canvas
            baseChart
            [options]="pieChartOptions"
            [data]="pieChartData"
            [labels]="pieChartLabels"
            [chartType]="pieChartType"
            [colors]="pieChartColors"
          >
          </canvas>
        </div>
      </div>
      <div fxFlex="50%" fxFlex.xs="100%" fxFlex.sm="100%">
        <div class="graph">
          <h6 class="pl-4 pb-5">Claims Count Last Month</h6>
          <div>
          <canvas class="p-3"
            baseChart
            [datasets]="horizantalbarChartData3"
            [labels]="horizantalbarChartLabels3"
            [options]="horizantalbarChartOptions"
            [legend]="horizantalbarChartLegend3"
            [chartType]="horizantalbarChartType3"
          >
          </canvas>
        </div>
        </div>
      </div>
    </div>
   </ng-container>
    <div class="col-12 px-0 pt-3">
    <div class="col-12 graph grap-table">
        <dxc-table class="table-responsive-sm dashabordTable pt-4">
          <tr class="header-filter">
            <th id="status" class="">
              {{ "processClaims.anomalies.status" | translate }}
            </th>
            <th id="claimNumber">
              {{ "processClaims.anomalies.claimNumber" | translate }}
            </th>
            <th id="insuredName">
              {{ "processClaims.anomalies.insuredName" | translate }}
            </th>
            <th id="policy">
              {{ "processClaims.anomalies.policy" | translate }}
            </th>
            <th id="type">
              {{ "processClaims.anomalies.climetype" | translate }}
            </th>
            <th id="submittedOn">
              {{ "processClaims.anomalies.submittedOn" | translate }}
            </th>
            <th id="fpl">
              {{ "processClaims.anomalies.fraudProbabilityIndex" | translate }}
            </th>
            <th id="siuInvestigator">
              {{ "processClaims.anomalies.siuInvestigator" | translate }}
            </th>
            <th id="siuManager">
              {{ "processClaims.anomalies.siuManager" | translate }}
            </th>
            <th id="details">
              {{ "processClaims.anomalies.details" | translate }}
            </th>
          </tr>
         <tr
        class="table-header"
        *ngFor="let item of analitics; index as i"
      >
      <td class="">
        <span class="mobile-label">
          {{ "processClaims.anomalies.status" | translate }}
        </span>
        <div class="status-ai" [ngClass]="item.summary.predictedFraud=='Fraud'?'error':'info'">
          <div class="status-innerdiv"></div>
          <span class="status-innersubdiv" >{{ item.summary.predictedFraud?item.summary.predictedFraud:'No Threat'}}</span>
        </div>
      </td>
      <td>
        <span class="mobile-label">
          {{ "processClaims.anomalies.claimNumber" | translate }}
        </span>
        <span>{{ item.summary.claimReferenceNumber }} </span>
      </td>
      <td>
        <span class="mobile-label">
          {{ "processClaims.anomalies.insuredName" | translate }}
        </span>
        <span>{{item.summary.fullName}}</span>
      </td>
      <td>
        <span class="mobile-label">
          {{ "processClaims.anomalies.policy" | translate }}
        </span>
        <span>{{item.summary.clientNumber}}</span>
      </td>
      <td>
        <span class="mobile-label">
          {{ "processClaims.anomalies.climetype" | translate }}
        </span>
        <span>{{item.summary.coverageTypeDescription}}</span>
      </td>
      <td>
        <span class="mobile-label">
          {{ "processClaims.anomalies.submittedOn" | translate }}
        </span>
        <span>{{ item.summary.createdDate }} </span>
      </td>
      <td class="text-center fraudScore">
        <span class="mobile-label">
          {{ "processClaims.anomalies.fpl" | translate }}
        </span>
        <div class="aiBadge" [ngClass]="item.summary.predictedFraud=='Fraud'?'badge-red':'badge-lightBlue'">
          <div class="aiBadge-innerdiv">
            <div class="aiBadge-subinnerdiv">
              <img src="{{RESOURCE_SERVER_URL+'/assets/images/'+dynamicImage(item.summary.predictedFraud)+'.svg'}}" class="badgeImage">
            </div>
           <span class="badge-label">{{ item.summary.predictedFraudScore?roundValue(item.summary.predictedFraudScore*100):0 }}</span>
          </div>
        </div>
      </td>
      <td>
        <span class="mobile-label">
          {{ "processClaims.anomalies.siuInvestigator" | translate }}
        </span>
        <span>{{item.summary.assignedTo}}</span>
      </td>
      <td>
        <span class="mobile-label">
          {{ "processClaims.anomalies.siuManager" | translate }}
        </span>
        <span>{{item.summary.routedClaimUserId}}</span>
      </td>
      <td>
        <span class="mobile-label">
          {{ "processClaims.anomalies.details" | translate }}
        </span>
        <span>
          <img (click)="onRegisterDeath(item)" src="{{
            this.RESOURCE_SERVER_URL +
              '/assets/images/next.svg'
          }}" alt="next" class="iconsColors">
        </span>
      </td>
      </tr> 
        </dxc-table>
        <div class="pagination-container">
          <dxc-paginator
            [totalItems]="totalItems"
            [itemsPerPage]="itemsPerPage"
            [currentPage]="page"
            [paginationActions]="paginationActions"
            (onGoToPage)="onPageAction($event, itemsPerPage)"
            [showGoToPage]="true"
            [itemsPerPageOptions]="itemsPerPageOptions"
            (itemsPerPageFunction)="itemsPerPageFunction($event)"
          >
          </dxc-paginator>
       </div>
    </div>
  </div>
  </div>
</ng-container>
</div>
